import { Action, TableActions, readPermissions } from "../../../features/roles";
import { TableName } from "../../../tables";

export const salesPermissions = (): TableActions[] => readPermissions().concat([
    { tableName: TableName.ADJUSTMENT_NOTES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.BUDGETS, actions: [Action.SAVE, Action.REMOVE] },
    // Collecting credit account payments (a check payment saves the received check)
    { tableName: TableName.CHECKS, actions: [Action.SAVE] },
    { tableName: TableName.CREDIT_PAYMENTS, actions: [Action.SAVE] },
    { tableName: TableName.CUSTOMER_TYPES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.CUSTOMERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.DELIVERY_ORDERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.DELIVERIES2, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.EMPLOYEES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.FISCAL_DOCUMENTS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.HOARD_ORDERS, actions: [Action.SAVE, Action.REMOVE] },
    // Creating and editing products (a new product also gets its prices and its base lot)
    { tableName: TableName.LOTS, actions: [Action.SAVE] },
    { tableName: TableName.PRODUCTS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.PRODUCT_PRICES, actions: [Action.SAVE] },
    { tableName: TableName.SALE_ORDERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.SETTINGS, actions: [Action.SAVE] },
    { tableName: TableName.STOCK, actions: [Action.SAVE] },
])
